import VisualBlocksVisualStore from './VisualBlocksVisualStore';
import ChatbotStore from './ChatbotStore';
import { ProjectsService } from '../../common/services';
import { RootStores } from '../../common/stores';
import { STORE_PROJECT_VISUAL_BLOCKS, STORE_VISUAL_BLOCKS_CHATBOT } from '../constants';
import { STORE_PROJECTS_ROOT_UI } from '../../common/constants';
import ChatbotService from '../services/ChatbotService';
import InstructWorkflowService from '../../instruct_workflows/services/InstructWorkflowService';

export { default as VisualBlocksVisualStore } from './VisualBlocksVisualStore';
export { default as ChatbotStore } from './ChatbotStore';

export function injectIntLabelsStores(obj: RootStores) {
    const service = new ProjectsService();
    const chatbotService = new ChatbotService();
    const instructWorkflowService = new InstructWorkflowService();
    obj[STORE_PROJECT_VISUAL_BLOCKS] = new VisualBlocksVisualStore(obj[STORE_PROJECTS_ROOT_UI], service);
    obj[STORE_VISUAL_BLOCKS_CHATBOT] = new ChatbotStore(
        chatbotService,
        instructWorkflowService,
        obj[STORE_PROJECT_VISUAL_BLOCKS],
        obj[STORE_PROJECTS_ROOT_UI]
    );
}

export type IntLabelsStores = {
    [STORE_PROJECT_VISUAL_BLOCKS]?: VisualBlocksVisualStore;
    [STORE_VISUAL_BLOCKS_CHATBOT]?: ChatbotStore;
};
